import React from 'react'

export default function Footer() {
  return (
    <>
    <footer id="cod__footer" className='mt-5'>
		
			 
         <div className="cod__copyright bg__cat--5">
             <div className="container">
                 <div className="row">
                     <div className="col-xs-12">
                         <div className="copyrigcod__inner">
                             <p>Copyright© <a href="#">Test website</a> 2022. All right reserved.</p>
                              
                         </div>
                     </div>
                 </div>
             </div>
         </div>
         
     </footer>

    </>
  )
}
